<template>
  <div>
    <div class="part">
      <el-row>
        <el-button type="primary" @click="toProcess">批量已读</el-button>
      </el-row>
    </div>
    <el-table
        :data="tableData"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange"
    >
      <el-table-column
          type="selection"
          width="55">
      </el-table-column>
      <el-table-column
          prop="bookId"
          label="挂号ID"
          width="120">
      </el-table-column>
      <el-table-column
          prop="visitNumber"
          label="病历号"
          width="120">
      </el-table-column>
      <el-table-column
          prop="bookTime"
          label="就诊时间"
          width="120">
      </el-table-column>
      <el-table-column
          prop="hosName"
          label="医院名称">
      </el-table-column>
      <el-table-column
          prop="deptName"
          label="科室名称"
          width="120">
      </el-table-column>
      <el-table-column
          prop="docName"
          label="医生姓名"
          width="120">
      </el-table-column>
      <el-table-column
          prop="docMobile"
          label="医生手机号"
          width="120">
      </el-table-column>
      <el-table-column
          prop="commonPatName"
          label="患者姓名"
          width="120">
      </el-table-column>
      <el-table-column
          prop="commonPatSex"
          label="患者性别"
          width="120">
      </el-table-column>
      <el-table-column
          prop="commonPatAge"
          label="患者年龄"
          width="120">
      </el-table-column>
      <el-table-column
          prop="commonPatPhone"
          label="患者手机号"
          width="120">
      </el-table-column>
      <el-table-column
          prop="actionInChief"
          label="主诉"
          width="120">
      </el-table-column>
      <el-table-column
          prop="diagnose"
          label="诊断"
          width="120">
      </el-table-column>
      <el-table-column
          prop="signPdfUrl"
          label="pdf签名文件"
          width="120">
        <template slot-scope="scope">
          <el-link type="primary">
            <a :href="scope.row.signPdfUrl" target="_blank">查看pdf病历文件</a>
          </el-link>
        </template>
      </el-table-column>
      <el-table-column
          prop="source"
          label="来源"
          width="120">
      </el-table-column>
      <el-table-column
          prop="status"
          label="是否质评"
          width="120">
      </el-table-column>
      <el-table-column
          prop="docIsRead"
          label="是否已阅"
          width="120">
      </el-table-column>
      <el-table-column
          prop="handleResult"
          label="是否通报"
          width="120">
      </el-table-column>
      <el-table-column
          prop="finalScore"
          label="病历得分"
          width="120">
      </el-table-column>
      <el-table-column
          prop="createTime"
          label="创建时间"
          width="120">
      </el-table-column>

      <el-table-column
          fixed="right"
          label="操作"
          width="100">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
        </template>
      </el-table-column>
    </el-table>

<div class="pagination">
  <el-pagination
      background
      @current-change="handleCurrentChange"
      layout="total, prev, pager, next"
      :total="total">
  </el-pagination>
</div>

  </div>
</template>
<script lang="js">
import dayjs from "dayjs"
import axiosUtil from "@/js/utils/AxiosUtils";

export default {
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      tableData: [],
      multipleSelection: [],
      total: 0
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    // toggleSelection(rows) {
    //   if (rows) {
    //     rows.forEach(row => {
    //       this.$refs.multipleTable.toggleRowSelection(row);
    //     });
    //   } else {
    //     this.$refs.multipleTable.clearSelection();
    //   }
    // },
    handleSelectionChange(val) {
      console.log(`=====handleSelectionChange========>`,val)
      this.multipleSelection = val;
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageSize=val
      this.getList()
    },

    handleClick(e) {
      this.$router.push("quality-control-detail?rowId="+e.id)
    },
    getList() {
      let _this = this
      let userInfo = JSON.parse(sessionStorage.getItem("loginInfo"))
      console.log(`====userInfo=========>`, userInfo)
      let options = {
        token: localStorage.getItem("token"),
        docId: userInfo.doc.id,
        docName: userInfo.doc.docName,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        service: "smarthos.user.book.case.history.quality.control.list",
      };
      console.log(`======req=======>`, options)
      axiosUtil(options, function (data) {
        console.log(`=====M=====>`, data.obj)
        _this.total = data.obj.amout
        let list = data.obj.caseHistoryQualityControlList
        if (list && list.length > 0) {
          list.map(item => {
            item.status = item.status == 1 ? '已处理' : '未处理'
            item.handleResult = item.handleResult == 0 ? '合格' : '通报'
            item.commonPatSex = item.commonPatSex == 'F' ? '女' : '男'
            item.docIsRead = item.docIsRead == '1' ? '已阅' : '未阅'
            item.createTime = dayjs(item.createTime).format('YYYY-MM-DD')
            return item
          })
        }
        _this.tableData = list
      });
    },

    //医生批量已读
    async toProcess() {
      let checkIds = []
      let unProcessIds = []

      //所有勾选的数据
      this.multipleSelection.forEach(item => {
        checkIds.push(item.id)
      })

      //勾选数据里未处理的数据
      this.multipleSelection.forEach(item2 => {
        if (item2.status !== '1') {
          unProcessIds.push(item2.id)
        }
      })

      let resArr = await this.getUniqueElements(checkIds, unProcessIds)
      console.log(`====checkIds,unProcessIds,resArr==>`, checkIds, unProcessIds, resArr)
      if (resArr.length === 0) {
        this.$message.error("至少选择一条未处理数据");
        return
      }
      let options = {
        token: localStorage.getItem("token"),
        qualityControlIdList: resArr,
        service: "smarthos.user.book.case.history.quality.control.doc.beach.read",
      };
      axiosUtil(options, (data) => {
        console.log(`=====M=处理结果====>`, data)
        // this.tableData = data.data
        this.pageSize=1
        this.getList()
      });
    },

    /**
     * 去除数组中公共元素
     * @param arr1
     * @param arr2
     * @returns {*[]}
     */
    getUniqueElements(arr1, arr2) {
      return new Promise((resolve, reject)=>{
        const set1 = new Set(arr1);
        const set2 = new Set(arr2);
        const uniqueElements = [];

        for (const item of set1) {
          if (!set2.has(item)) {
            uniqueElements.push(item);
          }
        }

        for (const item of set2) {
          if (!set1.has(item)) {
            uniqueElements.push(item);
          }
        }
        resolve(uniqueElements)
      })
    }

    //
  }

}
</script>
<style lang="scss">
.pagination{
  padding: 10px 0;
  display: flex;
  justify-content: right;
}
</style>